import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-files"
}
const _hoisted_2 = ["accept"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Upload = _resolveComponent("Upload")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($options.uploads.length || $options.files.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.uploads, (upload) => {
            return (_openBlock(), _createBlock(_component_Upload, {
              key: upload.id,
              name: upload.file.name,
              size: upload.file.size,
              error: !!upload.error,
              processing: true,
              onRemove: $event => ($options.removeUpload(upload.id)),
              onRetry: $event => ($options.retryUpload(upload.id))
            }, null, 8 /* PROPS */, ["name", "size", "error", "onRemove", "onRetry"]))
          }), 128 /* KEYED_FRAGMENT */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.files, (file) => {
            return (_openBlock(), _createBlock(_component_Upload, {
              key: file.id,
              name: file.name,
              size: file.size,
              ext: file.ext,
              processing: file.processing,
              failed: file.failed,
              removing: file.removing,
              onRemove: $event => ($options.removeFile(file.id))
            }, null, 8 /* PROPS */, ["name", "size", "ext", "processing", "failed", "removing", "onRemove"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("input", {
      id: "file",
      ref: "file",
      type: "file",
      accept: $options.accept,
      style: {"display":"none"},
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {_ctx.$refs.file.value = null}, ["stop"])),
      onChange: _cache[1] || (_cache[1] = (...args) => ($options.onUpload && $options.onUpload(...args)))
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)
  ], 64 /* STABLE_FRAGMENT */))
}